export default function errorHandler(error) {
  return Promise.reject(error);
}
